@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.banners

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.banners.BannerDto

object GetBannersEndpoint : EndPoint<GetBannersEndpoint.Request, GetBannersEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String?,
    )

    class Response(
        val list: Array<BannerDto>,
        val total: Int,
    )
}